































































































































































































































































































































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { mapGetters, mapState, mapActions } from 'vuex';

import { STORE_KEY, store } from './_store';

import DealForm from './DealForm/DealForm.vue';
import DealProducts from './DealProducts/DealProducts.vue';
import DealInformation from './DealInformation/DealInformation.vue';
import DocumentFeed from '../../components/Details/DocumentFeed/DocumentFeed.vue';
import DealCorrections from './DealCorrections/DealCorrections.vue';

@Component({
  computed: {
    ...mapState(STORE_KEY, [
      'loading', 'loaded', 'fatalError',

      'filter', 'remains',

      'document', 'meta', 'products'
    ]),
    ...mapGetters(STORE_KEY, [
      'hasActions', 'canActionToWork', 'canActionConfirmAction', 'disableActionConfirmActionCall', 'canActionToFormation',
    ]),
  },
  methods: {
    ...mapActions(STORE_KEY, ['toWork', 'toFormation', 'confirmBasket', 'loadData', 'toReject', 'confirmDeal', 'setCorrected'])
  },
  components: {
    DealForm,
    DealProducts,
    DealInformation,
    DocumentFeed,
    DealCorrections
  }
})
export default class DealDetails extends Vue {

  @Prop() params!: any
  document!: any

  public TAB_VIEW_DETAILS = 0;
  public TAB_VIEW_FORM = 1;
  public TAB_VIEW_STATISTIC = 2;

  hActiveTab: number | null = null;
  products!: any[];

  get activeTab() {
    return this.hActiveTab ? this.hActiveTab : (this.isNew ? this.TAB_VIEW_FORM : this.TAB_VIEW_DETAILS);
  }

  set activeTab(value: number) {
    this.hActiveTab = value
  }

  public activeDetailTab = 0;

  get config() {
    return this.params || this.$route.params || {}
  }

  get isModal() {
    return this.params
  }

  get isNew() {
    return this.config.id == 'new'
  }

  get allowToWork() {
    const document = this.document
    if (!document.count_product_all) {
      return false
    } else if (document.type_id == 'd:deals_types:4') {
      return true;
    } else {
      const count_prev = document.count_prev_deals ? document.count_prev_deals : 0
      if (count_prev > 0) {
        return document.count_product_all > 0
      } else {
        return (document.operator_approved_id && document.logist_approved_id && document.accountant_approved_id) || !document.count_product_paid 
      }
    }
  }

  copyAddition() {
    let str: string = `Добавка: ${this.document.client_name}\nг ${this.document.point_city}, \n${this.document.point_address}\n`;

    str += this.products.map((item: any) => {
      console.log(item)
      return item.product_name + ' ' + item.product_container_name + ' * ' + item.container_quantity + ' = ' + (parseFloat(item.product_container_weight) * item.container_quantity).toFixed(2) + ' кг'
    }).join(',\n')

    const el = document.createElement("textarea");
    el.value = str;
    el.setAttribute("readonly", "");
    el.style.position = "absolute";
    el.style.left = "-9999px";
    document.body.appendChild(el);
    // @ts-ignore
    const selected = document.getSelection().rangeCount > 0 ? document.getSelection().getRangeAt(0) : false;
    el.select();
    // @ts-ignore
    document.execCommand("copy");
    // @ts-ignore
    document.body.removeChild(el);
    if (selected) {
    // @ts-ignore
      document.getSelection().removeAllRanges();
    // @ts-ignore
      document.getSelection().addRange(selected);
    }
    this.$buefy.snackbar.open(`Добавка скопирована`);
  }

  isMobile () {
    if( screen.width <= 760 ) {
      return true;
    }
    else {
      return false;
    }
  }

  public created() {
    // @ts-ignore
    if (!(STORE_KEY in this.$store._modules.root._children)) {
      this.$store.registerModule(STORE_KEY, store);
    }
  }

  public mounted() {
    console.log('details mounted', this.config)
    this.$store.dispatch(`${STORE_KEY}/loadData`, this.config);
  }

  @Watch('$route.params')
  public loadDocumentData(nV?: any, oV?: any) {
    if(!this.isModal || this.config.inline) {
      this.$store.dispatch(`${STORE_KEY}/loadData`, this.config);
    }
  }

  // @Watch('config.id')
  public reloadDocumentData(nV?: any, oV?: any) {
    this.$store.dispatch(`${STORE_KEY}/loadData`, this.config);
  }

  onNeedDataReload(documentId: string) {
    if (!this.isNew) {
      this.$store.dispatch(`${STORE_KEY}/loadData`, {
        ...this.config,
        silence: true
      });
    } else {
      this.$router.replace({
        name: 'deal-details',
        params: {
          id: documentId
        }
      })
    }
  }

  public goBack() {
    this.$router.back();
    // if (!this.params) {
    //   this.$router.push({ name: 'deal-list' });
    // } else {
    //   this.$emit('close');
    // }
  }

  beforeDestroy() {
    this.$store.dispatch(`${STORE_KEY}/reset`);
    // this.$store.unregisterModule(STORE_KEY);
  }

}
